import { useContext, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'

import RolePermissionContext from '../../context/RolePermissionContext'

const ErrorPage = () => {
  const { data2 } = useContext(RolePermissionContext)

  // const { loading, error, data } = useQuery(GET_USER_BY_ID)
  const [toNavigate, setToNavigate] = useState<any>('')
  const navigate = useNavigate()

  useEffect(() => {
    if (data2) {
      const sideMenuListWithAccess = getSideMenuList(data2)
      setToNavigate(sideMenuListWithAccess?.to)
    }
  }, [data2])

  function getSideMenuList(jsonData: any) {
    if (jsonData && jsonData.getModuleAcessByRole && jsonData.getModuleAcessByRole.data) {
      const permissions = jsonData.getModuleAcessByRole.data

      for (const permission of permissions) {
        if (permission.isAccess) {
          return permission.module.sideMenu // Return the side menu object
        }
      }
    }

    return null // Return null if no valid sideMenu object is found
  }

  const NavigateToHomePage = () => {
    navigate(toNavigate)
  }

  return (
    <>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          height: '80vh'
        }}
      >
        <img
          src={
            'https://chatbot-project.s3.ap-south-1.amazonaws.com/botgo/assets/images/404-dark.png'
          }
          alt=''
          style={{
            width: '30%',
            height: '30%'
          }}
        />
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            height: '10vh',
            fontSize: '20px',
            fontStyle: 'italic'
          }}
        >
          Sorry we can't find that page!Don't worry though,everthing is STILL AWESOME!
        </div>

        <div style={{ marginTop: '70px' }}>
          <button
            type='submit'
            id='kt_sign_up_submit'
            className='btn btn-lg btn-primary w-100 mb-5'
            onClick={NavigateToHomePage}
          >
            Go home
          </button>
        </div>
      </div>
    </>
  )
}

export default ErrorPage
